export default __webpack_public_path__ + "static/media/SJ.d25a6adc.svg";